//JavaScript Document
//

//-------------------------------------------------------------------------------------------------
// DOMツリー構築後に処理
// -------------------------------------------------------------------------------------------------
jQuery(document).ready(function() {

	$('header .sp_btn').click(function() {
		$(this).toggleClass('on');
		$('header .nav').slideToggle();
	});
	$('header .nav li').click(function() {
		var windowWisth = $(window).innerWidth();
		if(windowWisth < 800){
			$('header .sp_btn').toggleClass('on');
			$('header .nav').slideToggle();
		}
	});

	$('.product_slider').slick({
		autoplay: false,
		autoplaySpeed: 3000,
		arrows: true,
		slidesToShow: 2,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	});

	$('.more_slider').slick({
		autoplay: true,
		autoplaySpeed: 1500,
		arrows: false,
		slidesToShow: 1,
		fade: true,
		speed:1000,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	});

	new Vivus('introduction_mask', {
		type: 'scenario-sync',
		duration: 40,
		forceRender: false ,
		animTimingFunction:Vivus.EASE});

	$('.wrap').hover(
		function() {
			$(this).prev().addClass('on_cursor');
		},
		function() {
			$(this).prev().removeClass('on_cursor');
		}
	);

	$(".inview").on("inview", function () {
		$(this).addClass("view");
	});
	$(".inview_up").on("inview", function () {
		$(this).addClass("view");
	});
	$(".inview_zoomin").on("inview", function () {
		$(this).addClass("view");
	});

	$(window).scroll(function() {
		var windowHeight = $(window).innerHeight();
		var windowWisth = $(window).innerWidth();
		var scroll = $(window).scrollTop();
		if ($(window).scrollTop() + windowHeight > $('.odometer_01').offset().top){
			$('.odometer_01').html(60.2);
		}
		if ($(window).scrollTop() + windowHeight > $('.odometer_02').offset().top){
			$('.odometer_02').html(100);
		}

		if($(window).scrollTop() > windowHeight){
			$('.banner').addClass('view');
		}else{
			$('.banner').removeClass('view');
		}
		var docHeight = $(document).innerHeight(), //ドキュメントの高さ
		pageBottom = docHeight - ( windowHeight * 2 ); //ドキュメントの高さ - ウィンドウの高さ
		if(pageBottom <= scroll) {
			$('.banner').removeClass('view');
		}

		if(windowWisth < 800){
			// ▼▼ 背景拡大 ▼▼
			var cts01 = $('.cts_01').offset().top;
			var cts01_s = cts01 - windowHeight;
			var cts01_e = scroll - cts01_s;

			var cts02 = $('.cts_02').offset().top;
			var cts02_s = cts02 - windowHeight;
			var cts02_e = scroll - cts02_s;

			var cts03 = $('.cts_03').offset().top;
			var cts03_s = cts03 - windowHeight;
			var cts03_e = scroll - cts03_s;

			var scale_01 = Math.floor(cts01_e) / windowHeight / 10 * 5;
			if(scale_01 < .5){
				var sum = 1.5 - scale_01;
			}else{
				var sum = 1;
			}
			$(".cts_01 .bg_area").css({
				"transform": "scale(" + sum + ")"
			});

			var scale_02 = Math.floor(cts02_e) / windowHeight / 10 * 5;
			if(scale_02 < .5){
				var sum = 1.5 - scale_02;
			}else{
				var sum = 1;
			}
			$(".cts_02 .bg_area").css({
				"transform": "scale(" + sum + ")"
			});

			var scale_03 = Math.floor(cts03_e) / windowHeight / 10 * 5;
			if(scale_03 < .5){
				var sum = 1.5 - scale_03;
			}else{
				var sum = 1;
			}
			$(".cts_03 .bg_area").css({
				"transform": "scale(" + sum + ")"
			});
			// ▲▲ 背景拡大 ▲▲

			// ▼▼ フェードイン ▼▼
			var cts01_fade_s = $('#yellow-power .ttl_wrap').offset().top + $('#yellow-power .ttl_wrap').outerHeight(true);
			var fade_01_check = scroll - cts01_fade_s;
			if( fade_01_check > 0){
				var fade_01 = Math.floor(fade_01_check) / windowHeight * 2;
				if(fade_01 < 1){
					$('.wrap_01').css('opacity', fade_01);
				}else{
					$('.wrap_01').css('opacity', '1');
				}
			}

			var cts02_fade_s = cts01_fade_s + $('#yellow-power .cts_01').outerHeight(true);
			console.log('scroll : ' + scroll);
			console.log(Math.floor(cts02_fade_s));
			var fade_02_check = scroll - cts02_fade_s;
			if( fade_02_check > 0){
				var fade_02 = Math.floor(fade_02_check) / windowHeight * 2;
				if(fade_02 < 1){
					$('.wrap_02').css('opacity', fade_02);
				}else{
					$('.wrap_02').css('opacity', '1');
				}
			}

			var cts03_fade_s = cts02_fade_s + $('#yellow-power .cts_02').outerHeight(true);
			var fade_03_check = scroll - cts03_fade_s;
			if( fade_03_check > 0){
				var fade_03 = Math.floor(fade_03_check) / windowHeight * 2;
				if(fade_03 < 1){
					$('.wrap_03').css('opacity', fade_03);
				}else{
					$('.wrap_03').css('opacity', '1');
				}
			}
			// ▲▲ フェードイン ▲▲
		}else{
			$(".cts_01 .bg_area").css({
				"transform": "scale(1)"
			});
			$(".cts_02 .bg_area").css({
				"transform": "scale(1)"
			});
			$(".cts_03 .bg_area").css({
				"transform": "scale(1)"
			});
			// $('.wrap_01').css('opacity', '1');
			// $('.wrap_02').css('opacity', '1');
			// $('.wrap_03').css('opacity', '1');
		}
	});

// ------------------------------------------------------------------------------------------
});
// ------------------------------------------------------------------------------------------ end




// -------------------------------------------------------------------------------------------------
// 全てのリソースを読み込み後に処理
// -------------------------------------------------------------------------------------------------
$(window).on('load',function(){
	$('.loading svg').addClass("view");
	$('.loading .board').addClass("out");
	setTimeout(function(){
		$('.loading svg').fadeOut(3000);
	},5000);
	setTimeout(function(){
		$('.loading').fadeOut(3000);
	},7000);
	setTimeout(function(){
		$('.bg_white').fadeOut(1500);
		$('#main .bg_area').addClass('view');
	},9000);
	setTimeout(function(){
		$('#main').addClass('view');
	},11500);
// ------------------------------------------------------------------------------------------
});
// ------------------------------------------------------------------------------------------ end
